module.exports = "<ng-template #navBarTemplate>\n  About us\n</ng-template>\n\n<div class=\"container mt-4 pb-4\">\n  <router-outlet></router-outlet>\n</div>\n"